module.exports = __webpack_public_path__ + "img/default-template-img.b2eac7a6.png";